import type { EcommerceItem } from '../../../../../types/analytics/ECommerce';
import type { Order, Variant } from '../../../../../types/CoreShoppingExperience';
import { PurchaseMode } from '../../../../../types/CoreShoppingExperience';
import UpgradeType from '../../../../../types/airline/UpgradeType';
import isAutoCampaign from '../../campaign/isAutoCampaign';
import { hasContinuousPricingFromPurchaseOption } from './hasContinuousPricing';

const convertOrderToItem = (order: Order, variant: Variant): EcommerceItem => {
  const { purchaseOptions, upgradeType, fromCabin, textKey } = variant;
  const { totalAmount, totalTax, paymentOption, quantity, instantUpgrade } = order;

  const purchaseMode = instantUpgrade ? PurchaseMode.INSTANT : PurchaseMode.BID;
  const purchaseOption = purchaseOptions.find(
    (v) => v.paymentOption === paymentOption && v.purchaseMode === purchaseMode,
  );

  const paymentBreakdown = purchaseOption?.paymentBreakdown;
  const campaign = purchaseOption?.campaign;

  const item: EcommerceItem = {
    index: undefined,
    itemName: `${upgradeType} - ${purchaseMode} - ${paymentOption}`,
    itemBrand: textKey,
    price: totalAmount,
    tax: totalTax ?? 0,
    fee: paymentBreakdown?.fees?.reduce((acc, iter) => acc + iter.amount, 0) ?? 0,
    quantity,
    upgradeType,
    fromCabin,
    purchaseMode,
    paymentOptions: [paymentOption],
    purchaseOptionSettings: undefined,
    hasSeatMapOption: upgradeType === UpgradeType.EXTRA_SEAT,
    seats: [],
    blockedSeats: [],
    discount: purchaseOption?.campaign?.percentReduction ?? 0,
    autoCampaign: isAutoCampaign(campaign),
    autoCampaignDiscount: campaign && isAutoCampaign(purchaseOption?.campaign) ? campaign.percentReduction : 0,
    continuousPricing: hasContinuousPricingFromPurchaseOption(purchaseOption),
    pointsFee: 0,
  };

  if (purchaseMode === PurchaseMode.BID && purchaseOption) {
    item.purchaseOptionSettings = purchaseOption.settings;
  }

  return item;
};

export default convertOrderToItem;
